import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Screens/TermOfUse/TermOfUse.tsx");
